export function InvoiceUnitCreditCtrl ($uibModalInstance, $scope, $translate, sessionObjAPI, units) {

  $scope.units = units;
  $scope.company = sessionObjAPI.company();

  $scope.selectedItem = null;

  if ($scope.company.company_variable_fields.plate_number_name) {
    $scope.regoLabel = $scope.company.company_variable_fields.plate_number_name;
  }
  else {
    $scope.regoLabel = sessionObjAPI.countrySettings().rego_label;
  };

  $scope.tableSettings = {
    columns: [
      {
        field : 'build_date',
        header: {
          text: $translate.instant('VEHICLE_SPACE.BUILD_DATE')
        }
      },
      {
        field : 'make',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MAKE')
        }
      },
      {
        field : 'model',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MODEL')
        }
      },
      {
        field : 'body_type',
        header: {
          text: $translate.instant('VEHICLE_SPACE.BODY_TYPE')
        }
      },
      {
        field : 'group_or_franchise_name',
        header: {
          text: $translate.instant('COMPANY_SPACE.FRANCHISE.GROUP_FRANCHISE')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_UNITS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowClick = function (event) {
    if (event.row.id) {
      if (event.row === $scope.selectedItem) {
        $scope.selectedItem = null;
      } else {
        $scope.selectedItem = event.row;
      }
    }
  };

  $scope.save = function () {
    $uibModalInstance.close($scope.selectedItem);
  };
}